var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7 28A10.6 10.6 0 0134 37.7h-6L16.9 45v-7.3l11.3-7.3h6a3.3 3.3 0 003.3-3c.4-5.6.3-11.2 0-16.9a3.1 3.1 0 00-3-2.8 195.2 195.2 0 00-23.8 0 3.1 3.1 0 00-3 2.9c-.4 5.6-.4 11.2 0 16.8a3.3 3.3 0 003.3 3h6v7.3h-6A10.6 10.6 0 01.3 28c-.4-6-.4-12 0-18A10.5 10.5 0 0110 .4a175.7 175.7 0 0125 0 10.5 10.5 0 019.6 9.6c.4 6 .5 12 .1 18z",
    fill: "#FF5100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChat);
export default __webpack_public_path__ + "static/media/live-chat.8c5a2cb7546b0aa7d3dd34152a10c7ff.svg";
export { ForwardRef as ReactComponent };